module.exports = __webpack_public_path__ + "static/Stephanie-Lieber-afe48065de68678f481b7119ad625917.png";